import type { ReactNode } from 'react';

/**
 * Formatacao pequena e segura para textos controlados pelo Admin.
 * Marcadores suportados: **negrito**, *italico* e __sublinhado__.
 * Nao interpreta HTML vindo do banco; o React escapa todo texto automaticamente.
 */
export function hasNotificationFormatting(value: string): boolean {
  return /\*\*[^*\n]+\*\*|__[^_\n]+__|\*[^*\n]+\*/.test(value || '');
}

export function renderNotificationText(value: string): ReactNode {
  const parts = (value || '').split(/(\*\*[^*\n]+\*\*|__[^_\n]+__|\*[^*\n]+\*)/g);
  return parts.map((part, index) => {
    if (part.startsWith('**') && part.endsWith('**') && part.length > 4) {
      return <strong key={index} className="font-bold">{part.slice(2, -2)}</strong>;
    }
    if (part.startsWith('__') && part.endsWith('__') && part.length > 4) {
      return <u key={index}>{part.slice(2, -2)}</u>;
    }
    if (part.startsWith('*') && part.endsWith('*') && part.length > 2) {
      return <em key={index}>{part.slice(1, -1)}</em>;
    }
    return part;
  });
}
